<pds-module-header title="Compras">
  <pds-new-breadcrumb [items]="[{ label: 'Compras' }]" />

  <pds-menu-cards-container>
    <pds-menu-card title="Pedido de Compra" *allowTo="[['compras-listagem']]" subtitle="Registros de pedidos de compra" [routerLink]="['pedidos-de-compra']" [relative]="true" titleAttribute="Compras" />

    <pds-menu-card title="Painel Fiscal" *allowTo="[['compras-painel-fiscal-listagem']]" subtitle="Vincular NF-e com pedidos de compra" [routerLink]="['painel-fiscal']" [relative]="true" titleAttribute="Painel Fiscal" />
  </pds-menu-cards-container>
</pds-module-header>
